export class CodeSystemConst {
    static GIOI_TINH = 'GIOI_TINH';
    static DAN_TOC = 'DAN_TOC';
    static LV_VAN_BAN = 'LV_VAN_BAN';
}

export class ComboBoxTableCode {
    
    static GetAllUsers = 'GetAllUsers';
    static GetAllUserByPermission = 'GetAllUserByPermission';
    static GetAllTenantToDLL = 'GetAllTenantToDLL';
    static GetAllQuestionToDLL = 'GetAllQuestionToDLL';
    static GetAllMainToDLL = 'GetAllMainToDLL';
    //CommonEnum
   
}


interface Option {
    label: string;
    value: string;
    age: number;
}

export const Level_Phan_Quyen = [

]

